var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kanban"},[_c('img',{staticClass:"kanban-img",attrs:{"src":_vm.kanbanImg}}),_c('p',{staticClass:"kanban-txt"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }